import React, { useEffect, useRef } from 'react';
import { googleAuthService, GoogleUser } from '../services/googleAuthService';

interface GoogleAuthButtonProps {
  onSuccess: (user: GoogleUser) => void;
  onError?: (error: string) => void;
  className?: string;
}

export default function GoogleAuthButton({ onSuccess, onError, className = '' }: GoogleAuthButtonProps) {
  const buttonRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const loadGoogleScript = () => {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      script.onload = () => {
        if (buttonRef.current) {
          try {
            googleAuthService.renderGoogleButton(buttonRef.current.id, onSuccess);
          } catch (e: any) {
            onError?.(e.message);
          }
        }
      };
      script.onerror = () => onError?.('Failed to load Google API script');
      document.body.appendChild(script);
    };

    if (!window.google) {
      loadGoogleScript();
    } else {
      if (buttonRef.current) {
        try {
          googleAuthService.renderGoogleButton(buttonRef.current.id, onSuccess);
        } catch (e: any) {
          onError?.(e.message);
        }
      }
    }
  }, [onSuccess, onError]);

  return (
    <div className={`google-auth-button ${className}`} style={{ width: '100%' }}>
      <div ref={buttonRef} id="google-auth-button" style={{ width: '100%' }} />
    </div>
  );
}
